import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@abp/ng.core';
import { Observable } from 'rxjs/internal/Observable';
import { AppPageModel, StaticPageModel } from '../models';
import { shareReplay, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root',
})
export class AppPageService {
  private _http: HttpClient;
  private _baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
  public customPages$: Observable<StaticPageModel[]>;
  public customPagesSubject: BehaviorSubject<StaticPageModel[]> = new BehaviorSubject<
    StaticPageModel[]
  >([]);

  constructor(http: HttpClient, environmentService: EnvironmentService) {
    this._http = http;
    this._baseUrl = environmentService.getApiUrl('default');
    this.customPagesSubject.next([]);
    this.customPages$ = this.customPagesSubject.asObservable();
  }

  getAllPages(): Observable<StaticPageModel[]> {
    const URL = this._baseUrl + `/api/app/app-page/all`;
    return this._http
      .get<StaticPageModel[]>(URL)
      .pipe(tap(pages => this.customPagesSubject.next(pages)));
  }

  private _pageBySlugCache: { [slug: string]: Observable<AppPageModel> } = {};

  getPageBySlug(slug: string): Observable<AppPageModel> {
    // Static pages (e.g. rules-and-regulations) don't change within a session, so cache
    // the result per slug and replay it — avoids a new request every time the tab is opened.
    if (!this._pageBySlugCache[slug]) {
      const URL = this._baseUrl + `/api/app/app-page/by-slug?slug=${slug}`;
      this._pageBySlugCache[slug] = this._http
        .get<AppPageModel>(URL)
        .pipe(shareReplay(1));
    }
    return this._pageBySlugCache[slug];
  }
}
